const file_utils = {
  isLocalhost() {
    return window.location.hostname === "localhost";
  },
  getCurrentHost: () => {
    return window.location.origin;
  },
  getApplicationId() {
    const path = window.location.pathname.split("/");
    const appID = path[4];
    return appID;
  },
  getMimeTypes(fileTypes) {
    if (!fileTypes) {
      //default set of allowed files if not specified in the schema for the field
      return [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/octet-stream",
      ];
    }
    const mimeTypes = {
      ".csv": "text/csv",
      ".doc": "application/msword",
      ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ".gif": "image/gif",
      ".htm": "text/html",
      ".html": "text/html",
      ".jpeg": "image/jpeg",
      ".jpg": "image/jpeg",
      ".odp": "application/vnd.oasis.opendocument.presentation",
      ".ods": "application/vnd.oasis.opendocument.spreadsheet",
      ".odt": "application/vnd.oasis.opendocument.text",
      ".png": "image/png",
      ".pdf": "application/pdf",
      ".ppt": "application/vnd.ms-powerpoint",
      ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ".svg": "image/svg+xml",
      ".tif": "image/tiff",
      ".tiff": "image/tiff",
      ".txt": "text/plain",
      ".xhtml": "application/xhtml+xml",
      ".xls": "application/vnd.ms-excel",
      ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ".zip": "application/zip",
    };
    let acceptedTypes = [];
    fileTypes.map((fileType) => {
      acceptedTypes.push(mimeTypes[fileType]);
      return false;
    });
    return acceptedTypes;
  },
  isValidFile(file, mime_types, file_size = 31457280) {
    return mime_types.indexOf(file.type) !== -1 && file.size <= file_size;
  },
  parseFileObjectForGraphql: (obj) => {
    let graphqlstr = "{";
    Object.keys(obj).forEach((x) => {
      if (obj[x] !== null) {
        graphqlstr += `${x}: "${obj[x]}",`;
      }
    });
    return graphqlstr + "}";
  },
};

export default file_utils;
